export default __webpack_public_path__ + "static/media/img-0182-ireland-full-face.700a545a.png";